<template>
  <div id="OrgDetailAptitude">
    <eb-panel>
      <eb-panel-header class="panel-header" slot="header">
        <span slot="title">企业资质</span>
      </eb-panel-header>
      <div slot="body">
        <div
          class="panel-body-row"
          v-for="aptitudeFile in orgAptitudeFileArr"
          :key="aptitudeFile.fileId"
        >
          <div class="panel-body-row-left" style="width: 100%;">
            <ul class="aptitudeFileShowArea">
              <li style="width:100px;height:100px;">{{aptitudeFile.fileDesc}}</li>
              <li>
                <div
                  class="aptitude-img-file"
                  v-image-preview
                  :data-img-preview-src="getFilePath(aptitudeFile.filePath)"
                  :style="'background:url(' + getFilePath(aptitudeFile.filePath)  +') no-repeat;background-size: contain; background-position: center center;cursor: pointer;'"
                ></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </eb-panel>
  </div>
</template>
<script>
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
import { imagePreview } from '@/directives/image-preview';
import { baseURL } from '@/plugins/axios.js';

export default {
  name: 'OrgDetailInfo',
  directives: {
    imagePreview: imagePreview
  },
  components: {
    ebPanel,
    ebPanelHeader
  },
  props: {
    orgAptitudeFileArr: {
      type: Array
    }
  },
  methods: {
    getFilePath(filePath) {
      return filePath ? baseURL + filePath : baseURL + '/static/img/147x147.png';
    }
  }
};
</script>
<style scoped lang="less">
ul,
li {
  list-style: none;
}
.aptitudeFileShowArea {
  /*margin-bottom: 10px;*/
}

.aptitudeFileShowArea li {
  line-height: 100px;
  float: left;
  vertical-align: bottom;
  margin-right: 5px;
}
.aptitude-img-file {
  width: 100px;
  height: 100px;
  border: 1px solid #cccccc;
  background-size: cover;
  background-position: center center;
}
</style>
